import { useEffect } from 'react';
import { useSessionStore } from '../contexts/SessionStore';

/** The addressed renderer lends its own Electron profile, never another host's. */
export default function StageCaptureReceiver() {
  const { addMessageHandler } = useSessionStore();
  useEffect(() => addMessageHandler((msg: { type: string; requestId?: string; buehne?: string; variante?: string; waitMs?: number; url?: string; partition?: string; discover?: boolean; expectedApps?: Array<{url:string;partition:string;email:string;freigabe?:string}>; kannNichtAufnehmbar?: boolean; kannKennung?: boolean; aufnahmeAusweis?: { token: string; hosts: string[]; partitionen: string[] } }) => {
    if (!['control:stage-capture', 'control:profile-probe'].includes(msg.type) || !msg.requestId) return;
    void (async () => {
      let result;
      try {
        const api = window.electronAPI;
        if (msg.type === 'control:profile-probe') {
          if (!api?.probeBrowserProfiles) throw Error('Dieses Electron-Fenster benötigt die Version mit Profilsuche; Anmeldung unbekannt.');
          result = { ok: true, ...await api.probeBrowserProfiles({ url: msg.url!, partition: msg.partition!, discover: msg.discover }) as object };
        } else {
        if (!api?.captureStage) throw Error('Dieses Fenster benötigt die Electron-Version mit Profil-Aufnahme.');
        result = { ok: true, capture: await api.captureStage({ buehne: msg.buehne!, variante: msg.variante!, waitMs: msg.waitMs!, expectedApps: msg.expectedApps, kannNichtAufnehmbar: msg.kannNichtAufnehmbar === true, kannKennung: msg.kannKennung === true, aufnahmeAusweis: msg.aufnahmeAusweis }) };
        }
      } catch (error) { result = { ok: false, error: error instanceof Error ? error.message : String(error) }; }
      const response = await fetch(msg.type === 'control:profile-probe' ? '/api/browser-profiles/result' : '/api/capture/buehne-ergebnis', { method: 'POST',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId: msg.requestId, ...result }) });
      if (!response.ok) throw Error(`Bühnenaufnahme nicht angenommen: HTTP ${response.status}`);
    })().catch(error => console.error('[stage-capture]', error));
  }), [addMessageHandler]);
  return null;
}
